import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonService } from "../../../services/api/mp-common.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { CountryState } from "../../models/mp-common/country-state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class CountryEffects {
	requested = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.countries.get),
			withLatestFrom(this.store.select(MpCommonSelectors.countries)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(state)
					? of(MpCommonActions.countries.getSuccess(state))
					: of(MpCommonActions.countries.getApi())
			)
		)
	);

	apiRequested = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.countries.getApi),
			switchMap(() => {
				return this.marketplaceService.countries().pipe(
					map((countries) =>
						MpCommonActions.countries.getSuccess({
							countries: _.sortBy(countries, "name"),
							loading: false
						})
					),
					catchError((error) =>
						of(MpCommonActions.countries.getFail(new FailState(error)))
					)
				);
			})
		)
	);

	constructor(
		private actions: Actions,
		private marketplaceService: MpCommonService,
		private store: Store<AppState>
	) {}

	private canUseStoreValue(country: CountryState): boolean {
		return !_.has(country, "error") && !country.loading;
	}
}
